import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";

import { SettingsContext } from "../../contexts";
import { DataHelper } from "../../helpers";
import { Money } from "../formatters";
import { getFileUrl } from "../../core/config/api.js";
import { getBaseCurrency } from "../../core/currency";

export function ListingProductDetails({ listing, product, isNetwork = false }) {
  const settings = useContext(SettingsContext);

  return (
    <div className="d-flex flex-grow-1">
      <div className="image ps-5 ps-lg-0 pt-2 pt-lg-0">
        {product.images.length > 0 && (
          <Link to={`/product/${listing.id}?${settings.iframeQueryParams}`}>
            <img src={getFileUrl(product.images[0].id)} />
          </Link>
        )}
        {!!listing?.listing_image_count && (
          <div className="h2 text-center">...</div>
        )}
      </div>

      <div className="details ps-5 ps-lg-4 pt-2">
        <Link to={`/product/${listing.id}?${settings.iframeQueryParams}`}>
          <h3>
            {product.brand.name} {product.model.name}
            {listing.internal_product === "owned" && (
              <span className="dot green" />
            )}
            {listing.internal_product === "no" && (
              <span className="dot purple" />
            )}
            {listing.internal_product === "to_be_procured" && (
              <span className="dot orange" />
            )}
          </h3>

          <Money
            currency={listing.currency ?? getBaseCurrency()}
            amount={listing.price}
            zero="PRICE ON REQUEST"
            className="price"
          />
          <span>{product.reference_number}</span>
          {listing.year && (
            <strong>
              {listing.year}
              <br />
            </strong>
          )}
          {!isNetwork && (
            <strong>
              {
                DataHelper.availability.find(
                  (a) => a.id === listing.availability
                )?.name
              }
            </strong>
          )}
          {isNetwork && (
            <strong>
              {listing.merchant_store_name} | {listing.merchant_first_name}{" "}
              {listing.merchant_last_name} | M
              {String(listing.merchant_id).padStart(4, "0")}
            </strong>
          )}
        </Link>
      </div>
      {listing.linked_order_quote_id && (
        <span className="dot mt-1 pt-1">
          <a
            className="p-1 ms-1"
            href={`/requests/orders/${listing.linked_order_request_id}/${listing.linked_order_quote_id}`}
          >
            <FontAwesomeIcon icon={faSync} size="lg" className="text-success" />
          </a>
        </span>
      )}
    </div>
  );
}
